module.exports = __webpack_public_path__ + "img/KHR.59ab2368.svg";